
// @ts-nocheck


export const localeCodes =  [
  "el",
  "en",
  "ar",
  "de",
  "es",
  "fr",
  "it",
  "ru",
  "sq"
]

export const localeLoaders = {
  "el": [{ key: "../../../../layers/core/i18n/vuetifyLocales/el.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/el.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_el_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/el.json", load: () => import("../../../../layers/core/i18n/locales/el.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_el_json" */), cache: true },
{ key: "../../../../customization_layers/zsh/i18n/vuetifyLocales/el.ts", load: () => import("../../../../customization_layers/zsh/i18n/vuetifyLocales/el.ts" /* webpackChunkName: "locale__b2c_next_customization_layers_zsh_i18n_vuetifyLocales_el_ts" */), cache: true },
{ key: "../../../../customization_layers/zsh/i18n/locales/el.json", load: () => import("../../../../customization_layers/zsh/i18n/locales/el.json" /* webpackChunkName: "locale__b2c_next_customization_layers_zsh_i18n_locales_el_json" */), cache: true }],
  "en": [{ key: "../../../../layers/core/i18n/vuetifyLocales/en.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/en.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_en_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/en.json", load: () => import("../../../../layers/core/i18n/locales/en.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_en_json" */), cache: true },
{ key: "../../../../customization_layers/zsh/i18n/vuetifyLocales/en.ts", load: () => import("../../../../customization_layers/zsh/i18n/vuetifyLocales/en.ts" /* webpackChunkName: "locale__b2c_next_customization_layers_zsh_i18n_vuetifyLocales_en_ts" */), cache: true },
{ key: "../../../../customization_layers/zsh/i18n/locales/en.json", load: () => import("../../../../customization_layers/zsh/i18n/locales/en.json" /* webpackChunkName: "locale__b2c_next_customization_layers_zsh_i18n_locales_en_json" */), cache: true }],
  "ar": [{ key: "../../../../layers/core/i18n/vuetifyLocales/ar.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/ar.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_ar_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/ar.json", load: () => import("../../../../layers/core/i18n/locales/ar.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_ar_json" */), cache: true }],
  "de": [{ key: "../../../../layers/core/i18n/vuetifyLocales/de.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/de.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_de_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/de.json", load: () => import("../../../../layers/core/i18n/locales/de.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_de_json" */), cache: true }],
  "es": [{ key: "../../../../layers/core/i18n/vuetifyLocales/es.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/es.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_es_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/es.json", load: () => import("../../../../layers/core/i18n/locales/es.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_es_json" */), cache: true }],
  "fr": [{ key: "../../../../layers/core/i18n/vuetifyLocales/fr.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/fr.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_fr_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/fr.json", load: () => import("../../../../layers/core/i18n/locales/fr.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_fr_json" */), cache: true }],
  "it": [{ key: "../../../../layers/core/i18n/vuetifyLocales/it.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/it.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_it_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/it.json", load: () => import("../../../../layers/core/i18n/locales/it.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_it_json" */), cache: true }],
  "ru": [{ key: "../../../../layers/core/i18n/vuetifyLocales/ru.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/ru.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_ru_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/ru.json", load: () => import("../../../../layers/core/i18n/locales/ru.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_ru_json" */), cache: true }],
  "sq": [{ key: "../../../../layers/core/i18n/vuetifyLocales/sq.ts", load: () => import("../../../../layers/core/i18n/vuetifyLocales/sq.ts" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_vuetifyLocales_sq_ts" */), cache: true },
{ key: "../../../../layers/core/i18n/locales/sq.json", load: () => import("../../../../layers/core/i18n/locales/sq.json" /* webpackChunkName: "locale__b2c_next_layers_core_i18n_locales_sq_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../../../../i18n/i18n.config.ts?hash=133101b8&config=1" /* webpackChunkName: "__i18n_config_ts_133101b8" */)
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute",
    "alternateLinkCanonicalQueries": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "el",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/el.ts",
        "/b2c-next/layers/core/i18n/locales/el.json",
        "/b2c-next/customization_layers/zsh/i18n/vuetifyLocales/el.ts",
        "/b2c-next/customization_layers/zsh/i18n/locales/el.json"
      ]
    },
    {
      "code": "en",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/en.ts",
        "/b2c-next/layers/core/i18n/locales/en.json",
        "/b2c-next/customization_layers/zsh/i18n/vuetifyLocales/en.ts",
        "/b2c-next/customization_layers/zsh/i18n/locales/en.json"
      ]
    },
    {
      "code": "ar",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/ar.ts",
        "/b2c-next/layers/core/i18n/locales/ar.json"
      ]
    },
    {
      "code": "de",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/de.ts",
        "/b2c-next/layers/core/i18n/locales/de.json"
      ]
    },
    {
      "code": "es",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/es.ts",
        "/b2c-next/layers/core/i18n/locales/es.json"
      ]
    },
    {
      "code": "fr",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/fr.ts",
        "/b2c-next/layers/core/i18n/locales/fr.json"
      ]
    },
    {
      "code": "it",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/it.ts",
        "/b2c-next/layers/core/i18n/locales/it.json"
      ]
    },
    {
      "code": "ru",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/ru.ts",
        "/b2c-next/layers/core/i18n/locales/ru.json"
      ]
    },
    {
      "code": "sq",
      "files": [
        "/b2c-next/layers/core/i18n/vuetifyLocales/sq.ts",
        "/b2c-next/layers/core/i18n/locales/sq.json"
      ]
    }
  ],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "locale",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "el",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/el.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/el.json"
      },
      {
        "path": "/b2c-next/customization_layers/zsh/i18n/vuetifyLocales/el.ts"
      },
      {
        "path": "/b2c-next/customization_layers/zsh/i18n/locales/el.json"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/en.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/en.json"
      },
      {
        "path": "/b2c-next/customization_layers/zsh/i18n/vuetifyLocales/en.ts"
      },
      {
        "path": "/b2c-next/customization_layers/zsh/i18n/locales/en.json"
      }
    ]
  },
  {
    "code": "ar",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/ar.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/ar.json"
      }
    ]
  },
  {
    "code": "de",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/de.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/de.json"
      }
    ]
  },
  {
    "code": "es",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/es.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/es.json"
      }
    ]
  },
  {
    "code": "fr",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/fr.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/fr.json"
      }
    ]
  },
  {
    "code": "it",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/it.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/it.json"
      }
    ]
  },
  {
    "code": "ru",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/ru.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/ru.json"
      }
    ]
  },
  {
    "code": "sq",
    "files": [
      {
        "path": "/b2c-next/layers/core/i18n/vuetifyLocales/sq.ts"
      },
      {
        "path": "/b2c-next/layers/core/i18n/locales/sq.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
